export enum GameProductionState {
	Prototype = 0,
	Beta = 1,
	Alpha = 2,
	Production = 3,

	Deprecated = 4,
}
